import React, { useEffect, useState } from 'react'
import logoimg from '../../assets/MK1.3.png'
import senddata from "../../Data/data.js";
import { useNavigate } from 'react-router-dom';

function AddGroup() {

    const navigate = useNavigate()

    const [openAdd,setOpenAdd] = useState(false);

    const [groupName,setGroupName] = useState("");

    const [allGroups,setAllGroups] = useState([]);

    useEffect(()=>{
        getAllGroups();
    },[])

    const addGroup = ()=>{
        if(!groupName) return ;
        senddata("group/add_group",{groupName}, "POST").then((res) => {
            if (res.status !== 200) {
            alert('تأكد من الاتصال من الانترنت ');
            } else {
                alert('تم اضافة المجموعة بنجاح  ');
                getAllGroups();
            }
            });
    }

    const getAllGroups = ()=>{
        senddata("group/get_all_groups",{}, "GET").then((res) => {
            if (res.status !== 200) {
            alert('تأكد من الاتصال من الانترنت ');
            } else {
                setAllGroups(res.data);
            }
            });
    }

    const deleteGroup = (id)=>{
        senddata(`group/delete_group/${id}`,{}, "DELETE").then((res) => {
            if (res.status !== 200) {
            alert('تأكد من الاتصال من الانترنت ');
            } else {
                alert('تم حذف المجموعة بنجاح  ');
                getAllGroups();
            }
            });
    }

    const handleshowStudents =(group)=>{
      const id = group._id ;
      senddata(`group/get_all_group_students/${id}`,{}, "GET").then((res) => {
        if (res.status !== 200) {
        alert('تأكد من الاتصال من الانترنت ');
        } else {
            console.log("res",res.data);
            navigate("/groupStudents",{ state: {students:res.data , groupName:group.groupName } });
        }
        });
    }
    
  return (
    <div className=' bg-[#1A1A4C] text-white flex flex-col min-h-screen text-base font-semibold pb-40 '>
      {/* headers */}
        <div className='headers  '>
          <img src={logoimg} className='w-[70px] rounded-full mx-7 mt-2 ml-auto'/>
        </div>
        {/* form */}
        {/* form */}
        <div className='add_student p-5 w-screen text-right flex flex-col justify-end '>
            <p onClick={()=>{setOpenAdd(!openAdd)}} className='px-10 py-2 bg-[#da0000] w-fit rounded-full cursor-pointer'>{openAdd?"اخفاء القائمة":"اضافة مجموعة"}</p> 
          {openAdd&&
          <div >
            <div dir='rtl'  className=' grid grid-cols-2 rever gap-4 mb-8 mt-4'>
              <input 
                type="text"
                value={groupName}
                onChange={(e) => setGroupName(e.target.value)}
                className="bg-transparent border-b-2 border-[#eb0000] focus:outline-none p-2 text-right "
                placeholder='اسم المجموعة'
                />

            </div>
              <p onClick={addGroup} className='px-6 py-2 bg-[#da0000] w-fit rounded-full cursor-pointer'>اضافة مجموعة</p> 
          </div>
          }
        </div>
        <div className='all_student'>
          <div dir='rtl' className='flex flex-row items-center justify-between pl-4 mt-10'>
            <h2 className=' text-right mr-4 '> المجموعات :  </h2>
          </div>
          {allGroups.length && (
            <div className='w-full overflow-x-auto scrollbar-hidden px-6 mt-8 '>
              <div className='flex flex-row py-2 border-b-2 border-[#e9ad03] min-w-full w-fit ' > 
                  <div className='text-base w-[150px] text-center'>الاسم</div>
                  <div className='text-base w-[150px] text-center'>الطلاب</div>
                  <div className='text-base w-[100px] text-center'>مسح</div>
                </div>
              {allGroups?.map((group) => (
                <div className='flex flex-row py-2 border-b-2 border-[#e9ad03] min-w-full w-fit ' key={group._id}> 
                  <div className='text-base w-[150px] text-center'>{group.groupName}</div>
                  <div onClick ={()=>{handleshowStudents(group)}} className='text-base w-[150px] text-center'>عرض الطلاب</div>
                  <div className='text-base w-[100px] text-center flex justify-center'><p onClick={()=>{deleteGroup(group._id)}} className='  w-fit rounded-full cursor-pointer'>🗑️</p> </div>
                </div>
              ))}
            </div>
          )}
        </div>
    </div>
  )
}

export default AddGroup
